export default __webpack_public_path__ + "static/media/navLogo.4060b779.svg";